module.exports = __webpack_public_path__ + "static/img/on_HALL.7640d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/on_HALL.png
// module id = ZXwb
// module chunks = 1